/*
 * Copyright (c) 2023. Collabro Limited
 */

import React from "react";
import { CellProps } from "./MovementCell";
import { Typography, useTheme } from "@mui/material";
import ModelTrainingIcon from "@mui/icons-material/ModelTraining";

interface ExclusionCellProps extends CellProps {
  multiple: boolean;
  start: boolean;
  end: boolean;
}

const ExclusionCell = (props: ExclusionCellProps) => {
  const theme = useTheme();
  const calculateBorder = () => {
    if (props.multiple) {
      if (props.start) {
        return "5px 0 0 5px";
      } else if (props.end) {
        return "0 5px 5px 0px";
      } else {
        return 0;
      }
    } else {
      return 5;
    }
  };
  const determineCellType = () => {
    if (props.multiple) {
      if (props.start) {
        //This is the first cell of many ahead
        return (
          <>
            <div
              style={{
                display: "flex",
                color: "inherit",
              }}
            >
              <ModelTrainingIcon fontSize="small" />
              <Typography variant="caption" maxWidth={50} noWrap={true}>
                {props.location}
              </Typography>
            </div>
            <div>
              <Typography variant="caption" maxWidth={50} noWrap={true}>
                Exclusion
              </Typography>
            </div>
          </>
        );
      } else {
        //This is continuation
        return <span style={{ height: 44 }} />;
      }
    } else {
      //Single Cell
      return (
        <>
          <div
            style={{
              display: "flex",
              color: "inherit",
            }}
          >
            <ModelTrainingIcon fontSize="small" />
            <Typography variant="caption" maxWidth={100} noWrap={true}>
              {props.location}
            </Typography>
          </div>
          <div>
            <Typography variant="caption" maxWidth={50} noWrap={true}>
              Exclusion
            </Typography>
          </div>
        </>
      );
    }
  };

  return (
    <div
      style={{
        display: "flex",
        padding: 5,
        background: theme.palette.cells.exclusion.background,
        color: theme.palette.cells.exclusion.text,
        borderRadius: calculateBorder(),
        flexDirection: "column",
        alignItems: "flex-start",
        width: "100%",
        minHeight: 50,
      }}
    >
      {determineCellType()}
    </div>
  );
};

export default ExclusionCell;
